module.exports = __webpack_public_path__ + "img/ry2.16f6c718.png";